import classNames from 'classnames';
import { isAfter, isBefore, parseISO } from 'date-fns';
import { useMemo } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime, useIntl } from 'react-intl';

// import { getImageAtSize } from '../../../lib/utils';
import Button from '../../buttons/Button';

import styles from '../../../../styles/items/games/allstar.module.scss';

import AllStarLogoEN from '../../../../img/nhl/logo_molson_all_star_en.png';
import AllStarLogoFR from '../../../../img/nhl/logo_molson_all_star_fr.png';

interface AllStarGameItemProps {
    game: AllStarGame;
    participation: Participation;
    className?: string | null;
    cardClassName?: string | null;
}

function AllStarGameItem({
    game,
    participation,
    className = null,
    cardClassName = null,
}: AllStarGameItemProps) {
    const { locale } = useIntl();

    const {
        type,
        url,
        title = null,
        description = null,
        image = null,
        startAt = null,
        endAt = null,
        sportGame = null,
    } = game || {};
    const { startAt: sportStartAt = null } = sportGame || {};

    const { id: participationId = null } = participation || {};

    // TODO: this is very weird, it should work
    // const { url: imageUrl = null } =
    //     getImageAtSize !== null ? getImageAtSize(image, 'medium') : image || {};

    const { url: imageUrl = null } = image || {};

    const finalImagePath = useMemo(() => {
        if (imageUrl !== null) {
            return imageUrl;
        }
        if (locale === 'fr') {
            return AllStarLogoFR;
        }
        return AllStarLogoEN;
    }, [imageUrl, locale]);

    const startAtDate = useMemo(() => (startAt !== null ? parseISO(startAt) : null), [startAt]);
    const sportStartAtDate = useMemo(
        () => (sportStartAt !== null ? parseISO(sportStartAt) : null),
        [startAt],
    );
    const endAtDate = useMemo(() => (endAt !== null ? parseISO(endAt) : null), [startAt]);

    const canPlay = useMemo(() => {
        const date = new Date();

        return isAfter(date, startAtDate) && isBefore(date, endAtDate);
    }, [startAtDate]);

    const inner = (
        <>
            {description !== null ? <h4 className={styles.description}>{description}</h4> : null}
            {startAtDate !== null ? (
                <div className={styles.date}>
                    {type === 'nhl' ? (
                        <>
                            <FormattedDate
                                value={sportStartAtDate}
                                weekday="long"
                                month="long"
                                day="numeric"
                                // hour="2-digit"
                            />{' '}
                            <FormattedTime value={sportStartAtDate} />
                        </>
                    ) : (
                        <FormattedDate
                            value={startAtDate}
                            weekday="long"
                            month="long"
                            day="numeric"
                        />
                    )}
                </div>
            ) : null}

            <span className={styles.button}>
                <img src={finalImagePath} alt={title} className={styles.image} />
                {title !== null ? (
                    <h2 className={styles.title}>{title}</h2>
                ) : (
                    <FormattedMessage defaultMessage="Play" description="Button label" />
                )}
            </span>
        </>
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[type]]: typeof styles[type] !== 'undefined',
                    [styles.disabled]: !canPlay,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.wrapper}>
                {!canPlay ? (
                    <div
                        className={classNames([
                            styles.card,
                            { [cardClassName]: cardClassName !== null },
                        ])}
                    >
                        {inner}
                    </div>
                ) : (
                    <Button
                        href={
                            participationId !== null
                                ? `/${locale}/participation/${participationId}`
                                : url
                        }
                        disabled={!canPlay}
                        className={classNames([
                            styles.card,
                            { [cardClassName]: cardClassName !== null },
                        ])}
                    >
                        {inner}
                    </Button>
                )}
            </div>
        </div>
    );
}

export default AllStarGameItem;
